import { TimeLogApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

interface IDeleteSubmissionIntervalForMonth {
    id: string;
    month: string;
    year: number;
}

const useHttpDeleteSubmissionIntervalForMonth = () => {
    const { t } = useTranslation('clientTimeSheets');
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);

    const exec = (params: IDeleteSubmissionIntervalForMonth, deleteSubmissionIntervalCb: () => void) => {
        const { exec, abort } = timeLogApi.deleteSubmissionIntervalForMonth({
            query: {
                id: params.id,
                month: params.month,
                year: params.year,
            },
            onSuccess: () => {
                deleteSubmissionIntervalCb();
                return t('successfulUnsubmit');
            },
            onError: error => error,
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpDeleteSubmissionIntervalForMonth;
